"use strict";

var _ = require("lodash");

module.exports = /* @ngInject */ function(
  openFinApi,
  rediPlusLifeCycleManager,
  menuItemRepository,
  openFinWebAuthenticator,
  RediWindowService,
  rediVersionRepository,
  rediVersionCheck,
  eikonLightLauncher,
  sideBySideInitializer,
  sideBySideApi,
  eikonUsageCheck,
  roccUsageRepository,
  OpenfinWindowFactory,
  $q,
  $log
) {
  var that = this;
  var isInitializedDeferred = $q.defer();
  resolveInitializedIfNotExpectingInitWindowMessage();

  function resolveInitializedIfNotExpectingInitWindowMessage() {
    rediVersionCheck.isExpectingVersionFromRedi().then(function(result) {
      if (!result) {
        isInitializedDeferred.resolve();
      }
    });
  }

  that.initialize = function(initParams) {
    roccUsageRepository.setUsingRocc(!!initParams.isROCC);
    rediVersionRepository.set(initParams.rediVersion);
    rediVersionCheck.init(initParams.rediVersion);
    openFinWebAuthenticator
      .authenticate(initParams)
      .then(onAuthenticated, function(error) {
        return $q.reject(
          error ||
            new Error("An unexpected error occurred during authentication")
        );
      })
      .then(
        function() {
          $log.info("Initialization Complete");
          isInitializedDeferred.resolve();
        },
        function(error) {
          $log.error("Failed to initialize:", error);
          var message =
            (error && error.message) ||
            "An unexpected error occurred while initializing web apps";
          return OpenfinWindowFactory.createAndShowErrorWindow(
            "Initialization Error",
            message
          ).finally(function() {
            isInitializedDeferred.reject();
            return $q.reject(new Error(message));
          });
        }
      );
  };

  that.isInitialized = function() {
    return isInitializedDeferred.promise;
  };

  that.triggerFakeESO = function() {
    $log.info("Simulating ESO Event for debug!");
    sideBySideApi.triggerFakeESO();
  };

  that.publishMenuItemsOnEikonSessionClose = resendNonEikonMenuItems;

  that.relogin = function() {
    const message = `Workspace Relogin Process started.`;
    $log.info(message);
    openFinApi.publish("log-message", { message });

    rediPlusLifeCycleManager.stop(false).then(
      function() {
        sideBySideApi.reset();

        resendNonEikonMenuItems();

        onAuthenticated().then(
          function() {
            const message = "Workspace Relogin Process Complete";
            $log.info(message);
            openFinApi.publish("log-message", { message });
          },
          function(error) {
            $log.error("Failed to reestablish Workspace Session:", error);
            var message =
              (error && error.message) ||
              "Failed to reestablish Workspace Session.";
            openFinApi.publish("log-message", { message });
            return OpenfinWindowFactory.createAndShowErrorWindow(
              "Initialization Error",
              message
            );
          }
        );
      },
      error => {
        const message = "Failed to re-login to a new Workspace Session.";
        $log.error("message", error);
        resendNonEikonMenuItems();
        return OpenfinWindowFactory.createAndShowErrorWindow(
          "Initialization Error",
          message
        );
      }
    );
  };

  function resendNonEikonMenuItems() {
    menuItemRepository.get().then(
      function(menuItems) {
        publishNonEikonMenuItems(menuItems);
      },
      function(error) {
        $log.error("Failed to get menu items ", error);
      }
    );
  }

  function onAuthenticated() {
    rediPlusLifeCycleManager.start();
    return menuItemRepository.get().then(
      function(menuItems) {
        return launchAndInitializeEikonIfNecessary().then(
          function() {
            return publishMenuItems(menuItems);
          },
          function(error) {
            return publishNonEikonMenuItems(menuItems).finally(function() {
              return $q.reject(error);
            });
          }
        );
      },
      function(error) {
        $log.error("Failed to get menu items ", error);
        return $q.reject(error);
      }
    );
  }

  function launchAndInitializeEikonIfNecessary() {
    return eikonUsageCheck
      .isUsingEikonLight()
      .then(function(isUsingEikonLight) {
        if (isUsingEikonLight) {
          // 9005 port is chosen so that Symphony will find it (it scans ports 9000-9005) and also
          // it is high enough to not interfere with other instances of SxS that are started by
          // Eikon (which starts at 9000 on a user's local machine)
          return eikonLightLauncher.launch(9005).then(
            function() {
              return sideBySideInitializer
                .init()
                .then(undefined, function(error) {
                  const message = "SxS initialize failed. ";
                  $log.error(message, error);
                  openFinApi.publish("log-message", { message });
                  return $q.reject(error || new Error("SxS initialize failed"));
                });
            },
            function(error) {
              $log.error("Eikon Launch and Initialize Error: ", error);
              return $q.reject(
                error || new Error("Eikon Launch and Initialize Error")
              );
            }
          );
        }
      });
  }

  function publishNonEikonMenuItems(menuItems) {
    var rediMenuItems = menuItems.filter(item => item.platform !== "Eikon");
    return publishMenuItems(rediMenuItems);
  }

  function publishMenuItems(menuItems) {
    openFinApi.publish("redi-menu-items", _.reject(menuItems, "background"));
    return launchAlwaysOpenWindows(menuItems);
  }

  function launchAlwaysOpenWindows(menuItems) {
    var alwaysOpenWindows = _.filter(menuItems, "alwaysOpen");

    $log.info("Opening windows: " + JSON.stringify(alwaysOpenWindows));

    var promisedAlwaysOpenWindowLaunches = _.map(alwaysOpenWindows, function(
      menuItem
    ) {
      return RediWindowService.createRediWindowFromMenuItem(
        menuItem,
        null,
        "minimized"
      );
    });

    return $q.all(promisedAlwaysOpenWindowLaunches);
  }
};



// WEBPACK FOOTER //
// ./app/business/openFinWebClientInitializer.js